import { BaseModel } from "./baseModel";

export class MobSummaryModel extends BaseModel {
    public mobId:number;
    public mobNo:number;
    public mobName:string;
    public mulesingStatus:string;
    public ageCode:string;
    public breedCode:string;
    public sexCode:string;
    public woolQuality:string;
    public mobCount:number;
    public nlisTag:string;
}